import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import useTranslationHook from "../../../hooks/useTranslationHook";
import { fetchQuantaAPIData } from "../../../../redux/action/buyerAction";
import { Trans } from "react-i18next";

const ComparableProperties = ({ data }) => {
    const { t } = useTranslationHook();
    const dispatch = useDispatch();
    const currentBid = data?.high_bid_amt ?? data?.start_price;
    const previousBidRef = useRef(null);
    const [comparableProperties, setComparableProperties] = useState(5);

    useEffect(() => {
        if (previousBidRef.current !== currentBid) {
            previousBidRef.current = currentBid;
            fetchMultipleEndpoints();
        }
    }, [currentBid]);

    const fetchMultipleEndpoints = async () => {
        try {
            dispatch(fetchQuantaAPIData("comparable-price")).then(
                (response) => {
                    const averagePriceProject = Number(
                        response?.averagePriceProject ||
                            response?.averagePriceDistrict
                    );
                    // ADREC: guard against divide-by-zero / non-finite
                    // averages so the comparison never becomes Infinity% or NaN%.
                    const bid = Number(currentBid);
                    const percentage =
                        Number.isFinite(averagePriceProject) &&
                        averagePriceProject > 0 &&
                        Number.isFinite(bid)
                            ? Math.round(
                                  ((bid - averagePriceProject) /
                                      averagePriceProject) *
                                      100
                              )
                            : 0;
                    setComparableProperties(
                        Number.isFinite(percentage) ? percentage : 0
                    );
                }
            );
        } catch (error) {
            console.error("One of the requests failed:", error);
        }
    };

    return (
        <>
            <div className="bidder-box-items">
                <ul>
                    <li>
                        {/* <Trans
                            i18nKey="priceComparison"
                            values={{
                                percent: Math.abs(comparableProperties || 0),
                                direction:
                                    comparableProperties < 0
                                        ? t("lower")
                                        : t("higher"),
                            }}
                            components={{
                                highlight: (
                                    <strong
                                        className={
                                            comparableProperties < 0
                                                ? "green"
                                                : ""
                                        }
                                    />
                                ),
                            }}
                        /> */}
                        {/* {t("Current comparable properties")}
                        <span
                            className={
                                comparableProperties > 0
                                    ? "success-text"
                                    : "danger-text"
                            }
                        >
                            {t(
                                `${comparableProperties < 0 ? "Less" : "High"} Percentage`,
                                {
                                    percentage: Math.abs(
                                        comparableProperties || 0
                                    ),
                                }
                            )}
                        </span> */}
                    </li>
                </ul>
            </div>
        </>
    );
};

// ✅ Wrap with React.memo() for performance optimization
const MemoizedComparableProperties = React.memo(ComparableProperties);

// ✅ Set display name to fix the warning
MemoizedComparableProperties.displayName = "ComparableProperties";

export default MemoizedComparableProperties;
